import { ref } from "vue";

const mainContent = ref<HTMLElement | null>(null);

function skipToContent() {
  if (mainContent.value) {
    mainContent.value.focus();
  }
}

export default function useSkipToContent() {
  return { mainContent, skipToContent };
}
